// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

enum RecoveryMethod {
  ConnectedDevice = 'connected-device',
  RecoveryFile = 'recovery-file',
  Shamir = 'shamir',
}

export { RecoveryMethod };
